import apiNavigationAccess from '../api/navigationAccessAPI';

const search = async (userAccessType) => {
    return await apiNavigationAccess.search(userAccessType);
};

export default {
    search: search,
}